import { useUsers } from '../../metodos/userContext';
import { useContabilidadModel } from '../../modelos/Contabilidad/modeloContabilidad'
import React, { useEffect, useState } from 'react'
import { formatearFechaCorta, formatearPrecio} from '../../utils/utils'; // Importamos desde el archivo utils.js
import generarPdfCuentaCobroTutor from './funciones/generateCuentaCobro';
import { useCuentaCobroModel } from '../../modelos/CuentasCobro/modeloCuentasCobro';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import LoadingWidget from '../../components/Loadings/LoadingWidget';

const PagosTutor = () => {
  const {
    estadisticas,
    getEstadisticasTutor,
    loadingEstadisticas,
    errorEstasdisticas,
  } = useContabilidadModel();
  const {
    usuario
  } = useUsers();
  const {
    addCuentaCobro,
    cuentasDeCobro,
    getCuentaCobroTutor,
    idPago,
    loadingcuentaCobro,
    ultimoFechaPago,
    getEmpresasCobro,
    empresasACobrar,
    loadingempresasACobrar,
    errorempresasACobrar,
  } = useCuentaCobroModel();
  const {
    configuracion
  } = useConfiguracion();

  const {
    serviciosTotales = 0,
    saldoHabilitadoParaPago = 0,
    saldoPendienteTotal = 0,
    saldoPagadoTotal = 0,
    saldoPagodoReembolsadoTotal = 0,
    saldoBalanceTutor = 0,
    serviciosEntregados = 0,
    serviciosNoEntregados = 0,
    serviciosParaPagar = [],
    serviciosNoEntregadosLista = [],
  } = estadisticas || {};

  //NUEVOS ESTADOS
  const [activeTab, setActiveTab] = React.useState('disponibles');
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  //cargar EMPRESAS
  useEffect(() => {
    getEmpresasCobro(usuario.nombrewhatsapp);
  }, []);

  //al carga rempresas, seleccionamos la primera por deferecto
  useEffect(() => {
    if (empresasACobrar && empresasACobrar.length > 0 && !empresaSeleccionada) {
      setEmpresaSeleccionada(empresasACobrar[0].nombreEmpresa);
    }
  }, [empresasACobrar]);

  //cargar estadisticas de tutor y obtener cuentas de cobro de tutores
  useEffect(() => {
    if (empresaSeleccionada) {
      // Limpiar estados de éxito al cambiar de empresa
      setSubmissionSuccess(false);
      // Cargar estadísticas y cuentas de la empresa actual
      getEstadisticasTutor(usuario.nombrewhatsapp, empresaSeleccionada);
      getCuentaCobroTutor(empresaSeleccionada, usuario.nombrewhatsapp);
    }
  }, [empresaSeleccionada]);

  if (loadingempresasACobrar || !empresaSeleccionada) {
     return <LoadingWidget
        mensaje={"Cargando empresas"}
      />;
  }

  if (loadingEstadisticas) {
     return <LoadingWidget
        mensaje={"Cargando datos de la empresa"}
      />;
  }

  // --- Lógica de renderizado de pestañas de empresas ---
  const renderTabsEmpresas = () => (
    <div className="flex overflow-x-auto pb-4 gap-3 no-scrollbar">
      {empresasACobrar.map((emp) => {
        const isActive = empresaSeleccionada === emp.nombreEmpresa;
        return (
          <button
            key={emp.nombreEmpresa}
            onClick={() => setEmpresaSeleccionada(emp.nombreEmpresa)}
            className={`flex items-center whitespace-nowrap px-5 py-2.5 rounded-xl font-bold transition-all duration-200 border-2 ${
              isActive 
              ? 'bg-blue-600 border-blue-600 text-white shadow-lg scale-105' 
              : 'bg-white border-gray-100 text-gray-500 hover:border-blue-200'
            }`}
          >
            {emp.nombreEmpresa}
            <span className={`ml-3 px-2 py-0.5 rounded-lg text-xs ${isActive ? 'bg-blue-400 text-white' : 'bg-gray-100 text-gray-400'}`}>
              {emp.serviciosPendientes}
            </span>
          </button>
        );
      })}
    </div>
  );

  //boton para cuenta de cobro
  const generarPagoTutor = async() =>{
    setIsSubmitting(true);

    //generar pago en sistema
    const cuentaCobroData ={
      idPago: idPago,
      fechaPago: new Date(),
      precioCobro:saldoHabilitadoParaPago,
      urlArchivo:'',
      nameTutor: usuario.nombrewhatsapp,
      servicios: serviciosParaPagar,
    }
 
    await addCuentaCobro(empresaSeleccionada,cuentaCobroData);
    //generar pdf
    generarPdfCuentaCobroTutor(serviciosParaPagar, usuario, idPago)

    //estado exitoso
    setSubmissionSuccess(true);
  }

  //renderizar boton de descargar
  const renderBotonDescarga = () => {

    if (submissionSuccess) {
      return (
        <div className="mt-6 bg-blue-100 border-l-4 border-blue-500 text-blue-800 p-4 rounded-r-lg">
          <p className="font-bold">Solicitud enviada con éxito</p>
          <p className="text-sm">Tu cuenta de cobro ha sido generada y está en proceso de pago.</p>
        </div>
      );
    }

    // Verificación 1: No hay saldo para pagar
    if (saldoHabilitadoParaPago <= 0) {
      return (
        <div className="mt-6 bg-gray-100 text-gray-600 p-4 rounded-lg text-center">
          <p className="font-semibold">No tienes saldo habilitado para generar una cuenta de cobro.</p>
        </div>
      );
    }

    const ahora = new Date();
    const esViernes = ahora.getDay() === 5; // 0=Domingo, 1=Lunes,..., 5=Viernes
    const horaActual = ahora.getHours(); // Formato 24h (0-23)
    const esHorarioHabil = horaActual >= 8 && horaActual < 17; // 8:00 a 16:59
    const habilitarPagoExtraTemporaneo = configuracion.pagoExtraTemporaneo;

    // Verificación 2: Fuera del horario permitido
    if ((!esViernes || !esHorarioHabil) && !habilitarPagoExtraTemporaneo) {
      return (
        <div className="mt-6 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-r-lg">
          <p className="font-bold">Horario no disponible</p>
          <p className="text-sm">Solo puedes descargar tu cuenta de cobro los días viernes de 8:00 AM a 5:00 PM.</p>
        </div>
      );
    }

    // Verificación 3: Ya se generó un pago hoy
    if (ultimoFechaPago) {
      const fechaUltimoPago = ultimoFechaPago; // Convertir Timestamp a Date de JS
      const yaPagoHoy = fechaUltimoPago.getFullYear() === ahora.getFullYear() &&
                       fechaUltimoPago.getMonth() === ahora.getMonth() &&
                       fechaUltimoPago.getDate() === ahora.getDate();

      if (yaPagoHoy) {
        return (
          <div className="mt-6 bg-blue-100 border-l-4 border-blue-500 text-blue-800 p-4 rounded-r-lg">
            <p className="font-bold">Solicitud enviada</p>
            <p className="text-sm">Ya solicitaste una cuenta de cobro el día de hoy. Tu pago está en proceso.</p>
          </div>
        );
      }
    }

    //mostrar boton
    return (
        <button
          onClick={generarPagoTutor}
          disabled={isSubmitting} // Deshabilitar el botón mientras se envía
          className="w-full mt-4 inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-transform hover:scale-105 disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <>
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Procesando...
            </>
          ) : (
            <>
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              GENERAR CUENTA DE COBRO
            </>
          )}
        </button>
    );

  }

  return (
    <div className="bg-slate-50 min-h-screen p-4 sm:p-8">
      <div className="max-w-5xl mx-auto space-y-6">
        
        {/* NUEVO: Selector de Empresas */}
        <h2 className="text-sm font-bold text-gray-500 uppercase mb-3 tracking-widest">Selecciona una Empresa para cobrar</h2>
        {renderTabsEmpresas()}

        <div className="p-6 sm:p-8">
          {/* --- Encabezado --- */}
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
               Reporte: {empresaSeleccionada}
            </h1>
            <p className="text-gray-500 mt-1">Resumen financiero para {usuario.nombrewhatsapp}</p>
          </div>

          {/* --- Advertencia Importante --- */}
          <div className="mt-6 bg-red-50 border-l-4 border-red-500 text-red-800 p-4 rounded-r-lg" role="alert">
            <p className="font-bold">¡Atención! Política de Pagos</p>
            <p className="text-sm">
              Para mantener la contabilidad al día, los saldos pendientes de servicios con más de 6 meses de antigüedad expiran y no se mostrarán aquí. 
              <span className="font-semibold"> ¡Que no se te pasen las fechas, ponte las pilas!</span>
            </p>
          </div>
          
          <hr className="my-8" />

          {/* --- Saldos Principales --- */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-green-100 p-6 rounded-lg text-center">
              <h2 className="text-sm font-semibold text-green-800 uppercase">Saldo Habilitado para Pagar</h2>
              <p className="text-4xl font-extrabold text-green-700 mt-2">
                {formatearPrecio(saldoHabilitadoParaPago)}
              </p>
            </div>
            <div className="bg-orange-100 p-6 rounded-lg text-center">
              <h2 className="text-sm font-semibold text-orange-800 uppercase">Saldo Pendiente (Últimos 6 meses)</h2>
              <p className="text-4xl font-extrabold text-orange-600 mt-2">
                {formatearPrecio(saldoPendienteTotal)}
              </p>
            </div>
          </div>
          
          <hr className="my-8" />

          {/* --- Detalle de Servicios y Pagos --- */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 text-center">
            <div>
              <h3 className="text-gray-500">Servicios Totales</h3>
              <p className="text-2xl font-bold text-gray-800">{serviciosTotales}</p>
            </div>
            <div>
              <h3 className="text-gray-500">Ultima fecha de pago</h3>
              <p className="text-2xl font-bold text-gray-800">{formatearFechaCorta(ultimoFechaPago)}</p>
            </div>
            <div>
              <h3 className="text-gray-500">Id cuenta cobro</h3>
              <p className="text-2xl font-bold text-gray-800">{idPago}</p>
            </div>
            <div>
              <h3 className="text-gray-500">Servicios Entregados</h3>
              <p className="text-2xl font-bold text-green-600">{serviciosEntregados}</p>
            </div>
            <div>
              <h3 className="text-gray-500">Servicios No Entregados</h3>
              <p className="text-2xl font-bold text-red-600">{serviciosNoEntregados}</p>
            </div>
            <div>
              <h3 className="text-gray-500">Total Pagado</h3>
              <p className="text-2xl font-bold text-gray-800">{formatearPrecio(saldoPagadoTotal)}</p>
            </div>
            <div>
              <h3 className="text-gray-500">Total Reembolsado</h3>
              <p className="text-2xl font-bold text-gray-800">{formatearPrecio(saldoPagodoReembolsadoTotal)}</p>
            </div>
             <div>
              <h3 className="text-gray-500">Balance Neto</h3>
              <p className="text-2xl font-bold text-blue-600">{formatearPrecio(saldoBalanceTutor)}</p>
            </div>
          </div>

          {/* Boton para generar pago por tutor */}
          {renderBotonDescarga()}
       
        </div>

        {/* Contenedor de los botones de las pestañas */}
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-6" aria-label="Tabs">
            <button
              onClick={() => setActiveTab('disponibles')}
              className={`${
                activeTab === 'disponibles'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
            >
              Disponibles para Cobrar
            </button>
            <button
              onClick={() => setActiveTab('futuros')}
              className={`${
                activeTab === 'futuros'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
            >
              Próximos Pagos
            </button>
            <button
              onClick={() => setActiveTab('historial')}
              className={`${
                activeTab === 'historial'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors`}
            >
              Historial de Pagos
            </button>
          </nav>
        </div>

        <div className="mt-6">

          {/* Contenido para la Pestaña "Disponibles para Cobrar" */}
          {activeTab === 'disponibles' && (
                <div>
                  <h2 className="text-xl font-bold text-gray-800 mb-4">Desglose del Saldo Habilitado</h2>
                  {serviciosParaPagar && serviciosParaPagar.length > 0 ? (
                    <ul className="space-y-3">
                      {serviciosParaPagar.map((servicio) => (
                        <li key={servicio.codigo} className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center">
                          <div>
                            <p className="font-semibold text-gray-900">{servicio.materia}</p>
                            <p className="text-xs text-gray-500">Código: {servicio.codigo} | Entrega: {formatearFechaCorta(servicio.fechaentrega)}</p>
                          </div>
                          <span className="font-bold text-lg text-green-600">
                            {formatearPrecio(servicio.preciotutor - (servicio.getSumaBalanceTutor ? servicio.getSumaBalanceTutor() : 0))}
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-gray-500 text-center py-4">No hay servicios listos para pagar en este momento.</p>
                  )}
                </div>
          )}
          
          {/* Contenido para la Pestaña "Próximos Pagos" */}
          {activeTab === 'futuros' && (
            <div>
              <h2 className="text-xl font-bold text-gray-800 mb-4">Desglose del Saldo Habilitado en Futuro</h2>
              {serviciosNoEntregadosLista && serviciosNoEntregadosLista.length > 0 ? (
                <ul className="space-y-3">
                  {serviciosNoEntregadosLista.map((servicio) => (
                    <li key={servicio.codigo} className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center">
                      <div>
                        <p className="font-semibold text-gray-900">{servicio.materia}</p>
                        <p className="text-xs text-gray-500">Código: {servicio.codigo}</p>
                      </div>
                      <span className="font-bold text-lg text-gray-600">
                        {formatearPrecio(servicio.preciotutor - (servicio.getSumaBalanceTutor ? servicio.getSumaBalanceTutor() : 0))}
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-500 text-center py-4">No tienes servicios pendientes de entrega.</p>
              )}
            </div>
          )}

          {/* Contenido para la Pestaña "Historial de Pagos" (¡MEJORADO!) */}
          {/* Contenido para la Pestaña "Historial de Pagos" (¡ORDENADO!) */}
          {activeTab === 'historial' && (
            <div>
              <h2 className="text-xl font-bold text-gray-800 mb-4">Historial de Cuentas de Cobro</h2>
              {cuentasDeCobro && cuentasDeCobro.length > 0 ? (
                <ul className="space-y-3">
                  {/* Ordenamos de mayor a menor según idPago antes del map */}
                  {[...cuentasDeCobro]
                    .sort((a, b) => b.idPago - a.idPago) 
                    .map((cuenta) => (
                      <li key={cuenta.idDocumento} className="bg-white p-4 rounded-lg shadow-sm flex justify-between items-center">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 bg-blue-100 text-blue-600 rounded-full h-10 w-10 flex items-center justify-center font-bold">
                            {cuenta.idPago}
                          </div>
                          <div className="ml-4">
                            <p className="font-semibold text-gray-900">Monto Pagado: {formatearPrecio(cuenta.precioPagado)}</p>
                            <p className="text-xs text-gray-500">Fecha de Pago: {formatearFechaCorta(cuenta.fechaPago)}</p>
                          </div>
                        </div>
                        <a
                          href={cuenta.urlArchivo}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm font-medium text-blue-600 hover:text-blue-800 transition-colors"
                        >
                          Ver PDF
                        </a>
                      </li>
                    ))}
                </ul>
              ) : (
                <p className="text-gray-500 text-center py-4">No hay cuentas de cobro para mostrar.</p>
              )}
            </div>
          )}

        </div>

         
      </div>
    </div>
  );

}

export default PagosTutor